import { action, makeObservable, observable } from 'mobx';

import type { BaseModelData } from '../../../data/model';
import { AsyncCommand } from '../../../shared/common';
import { IEventAggregator } from '../../../shared/EventAggregator';
import { NumberInput } from '../../../shared/Form';
import { INavigationService } from '../../../shared/NavigationService';
import { StoreUrl } from '../../../shared/StoreUrl';
import { RequestQuoteInitiatedEvent } from './RequestQuoteActionEvents';

export class RequestQuoteActionState {
  @observable
  public code: string;

  public proceedToRequestQuoteCommand: AsyncCommand;

  private baseModel?: BaseModelData;

  public constructor(
    private readonly eventAggregator: IEventAggregator,
    private readonly navigation: INavigationService,
    private readonly quantityInput: NumberInput,
    code: string,
    private brandName?: string,
    private currencyCode?: string,
    private modelId?: string,
    private modelName?: string,
  ) {
    makeObservable(this);
    this.code = code;
    this.proceedToRequestQuoteCommand = new AsyncCommand(() => this.proceedToRequestQuote());
  }

  @action
  public initialize(baseModel: BaseModelData, code: string, currencyCode: string) {
    this.baseModel = baseModel;
    this.currencyCode = currencyCode;
    this.setCode(code);
  }

  @action
  public async proceedToRequestQuote() {
    this.notifyRequestQuoteInitiated();
    this.navigation.navigateTo(
      StoreUrl.requestQuoteUrl({
        configurationCode: this.code,
      }),
    );
  }

  @action
  public setCode(code: string) {
    this.code = code;
  }

  public notifyRequestQuoteInitiated() {
    this.eventAggregator.publish(
      new RequestQuoteInitiatedEvent(
        this.baseModel ?? { id: this.modelId, name: this.modelName, brandName: this.brandName },
        this.code,
        this.currencyCode,
        this.quantityInput.value,
      ),
    );
  }
}
